import React from 'react';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { 
  selectShowCreateSnippetModal,
  selectShowFileUploadModal,
  selectShowScrapeWebsiteModal,
  setShowCreateSnippetModal,
  setShowFileUploadModal,
  setShowScrapeWebsiteModal
} from '@/store/slices/content/contentUiSlice';
import { CreateSnippetModal } from './modals/CreateSnippetModal';
import { UploadFileModal } from './modals/UploadFileModal';
import { ScrapeWebsiteModal } from './modals/ScrapeWebsiteModal';

/**
 * ContentModalsProvider component that renders all content creation modals
 * based on their Redux state. This component should be rendered at the app level
 * to ensure modals are available throughout the application.
 */
export const ContentModalsProvider: React.FC = () => {
  const dispatch = useAppDispatch();
  
  // Get modal visibility states from Redux
  const showCreateSnippetModal = useAppSelector(selectShowCreateSnippetModal);
  const showFileUploadModal = useAppSelector(selectShowFileUploadModal);
  const showScrapeWebsiteModal = useAppSelector(selectShowScrapeWebsiteModal);

  // Handler functions to close modals
  const handleCloseCreateSnippetModal = () => {
    dispatch(setShowCreateSnippetModal(false));
  };

  const handleCloseFileUploadModal = () => {
    dispatch(setShowFileUploadModal(false));
  };

  const handleCloseScrapeWebsiteModal = () => {
    dispatch(setShowScrapeWebsiteModal(false));
  };

  return (
    <>
      {/* Create Snippet Modal */}
      <CreateSnippetModal
        open={showCreateSnippetModal}
        onOpenChange={handleCloseCreateSnippetModal}
      />

      {/* Upload File Modal */}
      <UploadFileModal
        open={showFileUploadModal}
        onOpenChange={handleCloseFileUploadModal}
      />

      {/* Scrape Website Modal */}
      <ScrapeWebsiteModal
        open={showScrapeWebsiteModal}
        onOpenChange={handleCloseScrapeWebsiteModal}
      />
    </>
  );
}; 